<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    center
    :title="title"
    width="80%"
    append-to-body
  >
    <div class="dialog-content">
      <SiruiSearch
        ref="baseInfoFormRef"
        :query="query"
        :columns="formColumn"
        :isQueryPanel="false"
        labelWidth="120px"
        @changeMethod="changeMethod"
      ></SiruiSearch>
      <vxe-grid
        border
        show-overflow
        show-footer
        resizable
        auto-resize
        ref="xTableRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :edit-rules="tableRules"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        :toolbar="{}"
        :data="tableData"
        :columns="tableColumnList"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @edit-closed="closeEditTableHandler"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        height="300"
      >
        <template v-slot:buttons>
          <el-button @click="addNewRowHandler" size="small" type="primary" class="vxe-btn-primary"
            >新增</el-button
          >
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
      </vxe-grid>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="addConfirmHandler" size="small" v-if="status == 'add'"
          >确认新增</el-button
        >
        <el-button type="primary" @click="editConfirmHandler" size="small" v-if="status == 'edit'"
          >确认调整</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { formFields, tableRules } from './index.js';
  import superviseContractAPI from '@/api/receivablesAndPayables/superviseContract.js';
  // import API from '@/api/intermodality/order.js';
  import goodsApi from '@/api/masterData/goods.js';
  export default {
    name: 'AddAndEditCostDialog',
    mounted() {
      this.getGoodsParentApi();
    },
    data() {
      return {
        dialogVisible: false,
        loading: false,
        query: {
          businessCategory: '05',
          productCode: [],
        },
        tableData: [],
        selectionList: [],
        title: '', //弹窗顶部名称
        status: '', //进入状态（add,edit）
        customerList: [], //客户列表
        ids: [],
        goodsTypeList: [], //商品名称
        goodsCategoryList: [], //商品类别
      };
    },
    methods: {
      async changeMethod({ val, prop }) {
        console.log(val, prop, '点击切换');
        const rowData = val && Array.isArray(val) ? val[0] : val;
        if (prop == 'contractNo') {
          console.log('rowData', rowData);
          this.query = {
            ...this.query,
            contractNo: rowData?.contractNo,
            projectInitiationNo: rowData?.projectNo,
            projectName: rowData?.projectName,
          };
          this.customerList = [];
          this.getProjectByContract();
          this.getGoodsParentApi();
          if (this.status == 'edit') {
            this.getExpenseTableData();
          }
        } else if (prop == 'customerNo') {
          this.query = {
            ...this.query,
            customerNo: val,
            customerName: this.customerList.find((item) => item.value == val)?.label,
          };
        }
      },
      // 切换商品名称
      productCodeChange({ row }) {
        console.log('切换商品名称');
        this.getGoodsCategoryApi(row);
      },
      // 切换商品类型
      productTypeChange({ row }) {
        console.log('切换商品类型', row);
        let arr = [];
        row.productType.forEach((item) => {
          let detailProductModel = this.goodsCategoryList.find(
            (item1) => item1.value == item
          )?.detailProductModel;
          if (detailProductModel) arr.push(detailProductModel);
        });
        console.log('切换商品类型', arr);
        arr = [...new Set(arr)];
        row.productModel = arr.join(',');
      },
      openModal(data = {}) {
        console.log('data', data);
        this.status = data.status ? data.status : '';
        console.log('status', this.status);
        if (this.status == 'add') {
          this.title = '新增费用';
          this.query = {
            businessCategory: '05',
            productCode: [],
          };
          this.tableData = [];
          this.getGoodsParentApi();
          // this.getProjectByContract(this.query.contractNo);
          this.dialogVisible = true;
          return;
        }
        if (this.status == 'edit') {
          this.title = '调整费用';
          this.query = {
            ...this.query,
            contractNo: data.contractNo,
            customerNo: data.customerNo,
          };
          this.getGoodsParentApi();
          this.getProjectByContract(this.query.contractNo);
          this.$nextTick(() => {
            this.getExpenseTableData(data.expenseNo);
          });
          this.dialogVisible = true;
          return;
        }
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
      // 确认新增
      async addConfirmHandler() {
        const postData = await this.getValidateTableData();
        this.loading = true;
        const { data } = await this.$axios.post(
          superviseContractAPI.ADD_EXPENSE,
          postData.tableData
        );
        this.loading = false;
        if (data.code == 0) {
          this.$message.success('新增成功');
          this.dialogVisible = false;
          this.$emit('refreshTable');
        } else {
          this.$message.error(data.msg);
        }
      },
      // 确认调整
      async editConfirmHandler() {
        const postData = await this.getValidateTableData();
        this.loading = true;
        const { data } = await this.$axios.post(
          superviseContractAPI.ADD_EXPENSE,
          postData.tableData
        );
        this.loading = false;
        if (data.code == 0) {
          this.$message.success('调整成功');
          this.dialogVisible = false;
          this.$emit('refreshTable');
        } else {
          this.$message.error(data.msg);
        }
      },
      // 删除行
      deleteBtnClickHandler() {
        console.log('selectionList', this.selectionList);
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      },
      // 新增一行
      async addNewRowHandler() {
        const $table = this.$refs.xTableRef;
        const { row } = await $table.insertAt(
          { expenseTypeName: '监管费', exchangeRate: '1', currencyCode: 'CNY' },
          0
        );
        await $table.setActiveRow(row);
      },
      // 更新列
      updateCol(row, fieldValue, field) {
        console.log(row, fieldValue, field, '====>');
        row[field] = fieldValue;
        if (field == 'originalPrice' || field == 'statementQuantity') {
          let price = Number(row['originalPrice']);
          let quantity = Number(row['statementQuantity']);
          let exchangeRate = Number(row['exchangeRate']);
          price = isNaN(price) ? 0 : price;
          quantity = isNaN(quantity) ? 0 : quantity;
          exchangeRate = isNaN(exchangeRate) ? 1 : exchangeRate;
          row['originalAmount'] = price * quantity;
          row['domesticAmount'] = price * quantity * exchangeRate;
        } else if (field == 'originalAmount') {
          row['domesticAmount'] = row['originalAmount'];
        }
      },
      // 选择行
      handleSelectionChange(row) {
        this.selectionList = row.selection;
        console.log('selectionList', this.selectionList);
      },
      // 获取费用清单数据
      async getExpenseTableData(expenseNo = null) {
        this.loading = true;
        this.selectionList = [];
        const postData = {
          ...this.query,
          productCode: this.query.productCode.join(','),
          expenseNo,
        };
        const { data } = await this.$axios.post(`${superviseContractAPI.GET_LIST_TABLE}`, postData);
        this.loading = false;
        if (data.code == 0) {
          this.tableData = data.data;
        } else {
          this.$message.error(data.msg);
        }
      },
      // 关闭的时候
      closeEditTableHandler() {},
      // 根据合同编号获取项目信息
      async getProjectByContract(contractNo) {
        const { data } = await this.$axios.post(`${superviseContractAPI.GET_CONTRACT_PAGE}`, {
          contractNo,
        });
        if (data.code == 0) {
          this.getCustomerByContract(data.data.records[0]);
          this.query = {
            ...this.query,
            projectInitiationNo: data.data.records[0].projectNo,
            projectName: data.data.records[0].projectName,
            customerNo: data.data.records[0].settlementEntityNo,
            customerName: data.data.records[0].settlementEntityName,
          };
        }
        console.log('data', data);
      },
      // 根据合同编号获取客户名称列表
      async getCustomerByContract(data) {
        console.log('data', data);
        let customerList = this.customerList;
        if (data.relatedNo) {
          customerList.push({ value: data.relatedNo, label: data.relatedName });
        }
        // if (data.settlementEntityNo) {
        //   this.customerList.push({value:data.settlementEntityNo,label:data.settlementEntityName})
        // }
        if (data.pledgeeNo) {
          customerList.push({ value: data.pledgeeNo, label: data.pledgeeName });
        }
        if (data.pledgorNo) {
          customerList.push({ value: data.pledgorNo, label: data.pledgorName });
        }
        // 去重
        var obj = {};
        var result = [];
        for (let i = 0; i < customerList.length; i++) {
          if (!obj[customerList[i].value]) {
            result.push(customerList[i]);
            obj[customerList[i].value] = true;
          }
        }
        this.customerList = result;
        this.query.customerNo = data.settlementEntityNo;
      },
      // 获取商品大类数据
      async getGoodsParentApi() {
        const { data } = await this.$axios.post(superviseContractAPI.PRODUCT_TYPE, {
          contractNo: this.query.contractNo,
        });
        if (data.code == 0) {
          this.goodsTypeList = data.data?.map((item) => {
            return {
              value: item.parentProductNo,
              label: item.productChName,
            };
          });
          console.log(this.goodsTypeList, '商品大类数据');
        } else {
          console.error('获取商品大类数据失败');
        }
      },
      // 根据商品名称查询商品类别
      async getGoodsCategoryApi(row) {
        // const productParentCodes = this.goodsTypeList
        // .filter((item) => this.query.productCode.includes(item.value))
        // .map((item) => item.value);
        const productParentCodes = row.productCode;
        const { data } = await this.$axios.post(goodsApi.GOODS_LIST_BY_TYPE, {
          parentProductStatus: 'ZT03',
          productParentCodes,
        });
        if (data.code == 0) {
          this.goodsCategoryList = data.data?.map((item) => {
            return {
              value: item.productDetailCode,
              label: item.productChName,
              detailProductModel: item.detailProductModel,
            };
          });
        } else {
          console.error('获取货物类型数据失败');
        }
      },
      // 将商品类型编码字符串转换为数组
      goodsTransferArray(val) {
        let str = [];
        if (val) {
          str = val.split(',');
        } else {
          str = null;
        }
        console.log(str, '商品类型字符串转数组');
        return str;
      },
      // 获取表格数据
      getValidateTableData() {
        this.closeEditTableHandler();
        return new Promise((resolve, reject) => {
          const $table = this.$refs.xTableRef;
          $table.validate((valid) => {
            if (valid) {
              const tableData = $table.getTableData().fullData;
              const formTableData = tableData.map((item) => {
                return {
                  ...item,
                  ...this.query,
                  expenseType: '01',
                  departmentCode: this.userInfo.departmentCode,
                  businessDepartmentCode: this.userInfo.departmentCode,
                  departmentName: this.userInfo.departmentName,
                  businessDepartmentName: this.userInfo.departmentName,
                  companyCode: this.userInfo.companyCode,
                  businessCompanyNo: this.userInfo.companyCode,
                  companyName: this.userInfo.companyName,
                  businessCompanyName: this.userInfo.companyName,
                  // 新增费用时创建方式为手动   01-系统   02-手动
                  createMethod: this.status == 'add' ? '02' : item.createMethod || null,
                  productCode: Array.isArray(item.productCode)
                    ? item.productCode.join(',')
                    : item.productCode,
                  productType: Array.isArray(item.productType)
                    ? item.productType.join(',')
                    : item.productType,
                };
              });
              resolve({ tableData: formTableData });
            } else {
              this.$message.error('请检查表格数据填写');
              reject({ tableData: [] });
            }
          });
        }).catch((e) => {
          console.error(e);
        });
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData;
      },
    },
    computed: {
      formColumn() {
        return formFields(this);
      },
      tableColumnList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          {
            field: 'expenseTypeName',
            title: '费用类型',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 120,
          },
          {
            field: 'accountPeriod',
            title: '应收账期',
            width: 240,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM',
                format: 'yyyy-MM',
                type: 'month',
              },
            },
          },
          {
            field: 'originalPrice',
            title: '结算单价（含税）',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['originalPrice']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['originalPrice']}
                    max={999999999.999999}
                    min={0}
                    precision={4}
                    onInput={(val) => this.updateCol(row, val, 'originalPrice')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
            // },
            // width: 150,
          },
          {
            field: 'statementQuantity',
            title: '结算数量',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['statementQuantity']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['statementQuantity']}
                    max={999999999.999999}
                    min={0}
                    precision={4}
                    onInput={(val) => this.updateCol(row, val, 'statementQuantity')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 120,
          },
          {
            field: 'unitName',
            title: '计量单位',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 120,
          },
          {
            field: 'originalAmount',
            title: '原币结算金额（含税）',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['originalAmount']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['originalAmount']}
                    max={999999999.999999}
                    min={0}
                    precision={4}
                    onInput={(val) => this.updateCol(row, val, 'originalAmount')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'currencyCode',
            title: '币种',
            width: 120,
          },
          {
            field: 'exchangeRate',
            title: '汇率',
            width: 120,
          },
          {
            field: 'domesticAmount',
            title: '本币结算金额（含税）',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['domesticAmount']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['domesticAmount']}
                    max={999999999.999999}
                    min={0}
                    precision={4}
                    onInput={(val) => this.updateCol(row, val, 'domesticAmount')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'periodDateFrom',
            title: '业务结算日期从',
            width: 240,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            field: 'periodDateUntil',
            title: '业务结算日期至',
            width: 240,
            editRender: {
              name: 'ElDatePicker',
              props: {
                clearable: true,
                valueFormat: 'yyyy-MM-dd',
              },
            },
          },
          {
            field: 'businessDocCode',
            title: '业务单据编码',
            width: 150,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
          {
            field: 'productCode',
            title: '商品名称',
            width: 150,
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
                multiple: true,
              },
              changeMethod: 'changeMethod',
              options: this.goodsTypeList,
              multiple: true,
              events: { change: (obj) => this.productCodeChange(obj) },
            },
          },
          {
            field: 'productType',
            title: '商品类型',
            width: 120,
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
                multiple: true,
              },
              options: this.goodsCategoryList,
              multiple: true,
              changeMethod: 'changeMethod',
              events: { change: (obj) => this.productTypeChange(obj) },
            },
          },
          {
            field: 'productModel',
            title: '规格',
            width: 120,
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
          },
        ];
      },
      tableRules() {
        return tableRules();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
